import { render, staticRenderFns } from "./orderrefund.vue?vue&type=template&id=35f88a61&scoped=true"
import script from "./orderrefund.vue?vue&type=script&lang=js"
export * from "./orderrefund.vue?vue&type=script&lang=js"
import style0 from "./orderrefund.vue?vue&type=style&index=0&id=35f88a61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f88a61",
  null
  
)

export default component.exports